import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ServiceStock } from '../service-stock.service';
import { gsap } from "gsap";
import { environment } from 'src/environments/environment';
import { toVh, toVhU, toVwU } from "../utils/ux";
import { combineLatest, map, Observable, Observer, of } from 'rxjs';
import { CustomerService } from '../services/customer.service';
import { UserProfile } from '../models/userProfile.model';
import { AccountsService } from '../services/accounts/accounts.service';
import { DepositService } from '../deposits/services/deposits.service';
import { TransfersMainService } from '../transfers/services/transfers-main.service';
import { UserService } from '../user.service';
import { CommonService } from '../common.service';
import { HttpRequest, HttpProviderService, IHttpSuccessPayload } from '@fpx/core';
import { SettingsService } from '../services/settings/settings.service';
import { MailBoxMainService } from '../mailbox/services/mailbox-main.service';
import { NativeStorageService } from "src/app/services/mobile/native-storage.service";


declare let $: any;

@Component({
  selector: 'app-welcome-user',
  templateUrl: './welcome-user.component.html',
  styleUrls: ['./welcome-user.component.scss']
})
export class WelcomeUserComponent implements OnInit {
  // Bhuvesh -- Start
  @ViewChild('centerLeafIcon') centerLeafIcon: ElementRef<HTMLDivElement>;
  @ViewChild('rightLeafIcon') rightLeafIcon: ElementRef<HTMLDivElement>;
  @ViewChild('leftLeafIcon') leftLeafIcon: ElementRef<HTMLDivElement>;
  @ViewChild('wavesIcon') wavesIcon: ElementRef<HTMLDivElement>;
  @ViewChild('profileIcon') profileIcon: ElementRef<HTMLDivElement>;
  @ViewChild('welcomeContent') welcomeContent: ElementRef<HTMLDivElement>;
  // Bhuvesh -- End

  constructor(
    public transfersMainService: TransfersMainService,
    public services: ServiceStock, 
    protected customerService: CustomerService, 
    private depositService: DepositService, 
    private _httpProvider: HttpProviderService,
    public mailBoxMainService: MailBoxMainService,
    public commonService: CommonService, 
    public accountService: AccountsService,
    public userService: UserService,
    private _nativeStorage:NativeStorageService
  ) { }
  helloTxt: string = 'HelloText.default';
  username: string = '';
  screenAnimationDelay: number = 1500;
  summaryData: any;
  accountsData: any;
  accountSummary: any;
  transactionCodeDetail = [];
  merchantDetail = [];
  accTransactionDetail = [];
  doStartAnimation: boolean = false;
  userImageUri: string = "./assets/images/profile.png";
  greenifyEnabledUSer = false;

  animationDone$: Observable<boolean>;

  ngOnInit() {
    this.services.greenifyEnabled = 'no';
    this.greenifyEnabledUSer = false;

    if (this.services.isDesktop()) {
      this.screenAnimationDelay = 1500;
    }
    this.helloTxt = this.services.helloText();
    let userProfile: UserProfile = this.customerService.getUserProfile();

    // sessionStorage.setItem('userId', userProfile.customerCode);
    // sessionStorage.setItem('customerCode', userProfile.customerCode);

    this.loadSummary();

    if (userProfile) {
      this.username = this.customerService.getCustomerFullName();
    } else {
      this.username = "Banker";
    }
    if (this.commonService.isHybrid()){
    this._nativeStorage.storeData('customerName', this.username);
    }
  }

  setupUserProfileAnimation() {

  }

  ngAfterViewInit() {
    const startSession = new CustomEvent('startSession', { detail: this });
    window.dispatchEvent(startSession);

    this.startAnimation();
    this.customerService.fetchUserProfilePic().subscribe({
      next: (res) => {
       
        this.userImageUri = res || "./assets/images/profile.png";
        this.userService.setUserProfileImage(this.userImageUri);
        // document.getElementById('userImage').setAttribute('src', this.userImageUri);
      }
    })

    // this.services.getUserImage(this.userImageFetchSuccess.bind([this]));
  }

  async loadSummary() {
    let summaryRes = "";
    this.mailBoxMainService.getMailLength();
    let loadMerchantData$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.services.retailStock.loadMerchantData();
        observer.next(true);
      });
    });

    let loadNFC$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.services.retailStock.loadNFC();
        observer.next(true);
      });
    });

    let loadTransactionCodeData$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.services.retailStock.loadTransactionCodeData();
        observer.next(true);
      });
    });

    let loadSummary$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        summaryRes = await this.services.retailStock.loadSummary();
        observer.next(true);
      });
    });

    let loadNickName$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.customerService.fetchAccountsNickname().then(x => {
          observer.next(true);
        });

      });
    });

    let loadPaymentService$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        await this.transfersMainService.loadTransfersService().then(x => {
          observer.next(true);
        });

      });
    });
    
    // await this.services.retailStock.loadPaymentMethod();

    combineLatest(loadMerchantData$, loadTransactionCodeData$, loadSummary$, loadNickName$, loadPaymentService$, loadNFC$).subscribe(([loadMerchantData, loadTransactionCodeData, loadSummary, loadNickName, loadPaymentService, loadNFC]) => {
      if (`${loadMerchantData}` && `${loadTransactionCodeData}` && `${loadSummary}` && `${loadNickName}` && `${loadPaymentService$}` && `${loadNFC}`) {

        if (summaryRes == 'openAccount') {
          this.services.retailStock.hasAccount = false;
          this.loadRoute(summaryRes);
        } else {
          // this.accountService.getList();
          // this.depositService.getDepositsList();
          this.services.retailStock.hasAccount = true;

          let fetchAccountStmt$ = new Observable<boolean>((observer) => {
            setTimeout(async () => {

              // await this.services.retailStock.fetchAccountStmt();

              console.log("...fetchaccountsmt done...");
              observer.next(true);
            });
          });

          combineLatest(fetchAccountStmt$, this.animationDone$).subscribe(([fetchAccountStmt, animartionDone]) => {
            if (`${fetchAccountStmt}` && animartionDone) {
              this.loadRoute(summaryRes);
            }
          });
        }
      }
    });
  }

  userImageFetchSuccess(imageData) {
    let img = imageData || "./assets/images/profile.png";
    this.userImageUri = img;
    document.getElementById('userImage').setAttribute('src', img);
  }

  startAnimation() {
    this.doStartAnimation = true;

    this.animationDone$ = new Observable<boolean>((observer) => {
      setTimeout(async () => {
        console.log("...animation done...");
        observer.next(true);
      }, 3500);
    });
  }

  loadRoute(hasAcc: any = 'overview') {
    if (this.customerService.customerInfo.isUserChild) {
      this.services.http.ActiveTab = "family-banking";
      this.services.router.navigate(['/home', "family-banking"]);
    } else {
      this.services.http.ActiveTab = hasAcc;
      this.services.router.navigate(['/home', hasAcc]);
    }
  }

 
  
}
